import React from 'react'
import { useSelection, useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import { getMapValue } from '@morningtrain/react-helpers'

function SelectedItemFields () {
  const selection = useSelection()
  const categoryId = useValue('id')
  const items = useValue('items')
  const selectedItems = selection.getSelected()
  const availableItemIds = items.map(item => getMapValue(item, 'id'))

  return selectedItems.map(id => {
    if (availableItemIds.includes(id)) {
      return null
    }

    return (
      <React.Fragment key={id}>
        <input type='hidden' name={`items[${categoryId}][]`} value={id} />
      </React.Fragment>
    )
  })
}

export default observer(SelectedItemFields)
